import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const ContentWrapper = styled.div``;

export const NotAvailable = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  margin-top: ${pxToRem('40px')};
  padding: ${pxToRem('24px')};
  border-radius: ${pxToRem('8px')};
  border: solid ${pxToRem('1px')} #ececed;
  align-items: center;
  justify-content: center;
`;
